import styled, { css } from 'styled-components';
export const DefaultContentContainerBackground = styled.div `
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--text-secondary);
  opacity: 0.1;
`;
export const DefaultContentContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border: 1px dashed
    ${({ $invalid }) => ($invalid ? 'var(--border-critical)' : 'var(--border-primary)')};
  border-radius: var(--radius-brand);
  text-align: center;
  cursor: pointer;
  position: relative;

  ${({ $size }) => $size === 'medium' &&
    css `
      padding: var(--space-250) var(--space-350);
    `};

  ${({ $size }) => $size === 'large' &&
    css `
      padding: var(--space-350) var(--space-700);
    `};

  ${({ $disabled }) => !$disabled &&
    css `
      &:hover {
        ${DefaultContentContainerBackground} {
          display: block;
        }
      }
    `}

  ${({ $accepted }) => $accepted &&
    css `
      background-color: var(--bg-brand-secondary);
      border-color: var(--border-brand);
    `};

  ${({ $rejected }) => $rejected &&
    css `
      background-color: var(--bg-critical-secondary);
      border-color: var(--border-critical);
    `};

  ${({ $disabled }) => $disabled &&
    css `
      cursor: not-allowed;
      border-color: var(--border-primary);
      background-color: var(--bg-secondary);
    `};
`;
export const ContentContainer = styled.div `
  width: 100%;
  height: 100%;
  outline: none;
  grid-column: 1 / -1;

  &:focus {
    ${DefaultContentContainer} {
      border-color: var(--border-primary);
    }
  }
`;
export const LoaderContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;
export const IconContainer = styled.div `
  margin: 0 var(--space-400);

  ${({ $orientation }) => $orientation === 'vertical' &&
    css `
      margin-bottom: var(--space-200);
    `};
`;
export const Headline = styled.div `
  display: flex;
  align-items: center;
  flex-direction: column;

  ${({ $size }) => $size === 'medium' &&
    css `
      font-size: var(--font-size-300);
      line-height: var(--font-line-height-200);
    `};

  ${({ $size }) => $size === 'large' &&
    css `
      font-size: var(--font-size-400);
      line-height: var(--font-line-height-400);
    `};

  ${({ $orientation }) => $orientation === 'vertical' &&
    css `
      flex-direction: column;
    `};

  ${({ $orientation }) => $orientation === 'horizontal' &&
    css `
      flex-direction: row;
    `};
`;
